import React, { useState } from "react" // useState kept for draftPrices
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { PricingTypeSelector } from "pagesV2/pro/Experiences/ListingScheduling/LengthAndRates/PricingTypeSelector"
import { LocalPricingTable } from "./LocalPricingTable"
import { Button, Flex, Form } from "antd"
import { Icon } from "ui/Icon"
import { spacings } from "themes/variables"
import { generateUUID } from "components/trips/utils"
import { PRICING_TYPES } from "pagesV2/pro/Experiences/ListingScheduling/utils/constants"
import { FullPayment } from "pagesV2/pro/Experiences/ListingScheduling/LengthAndRates/FullPayment"
import { Deposit } from "pagesV2/pro/Experiences/ListingScheduling/LengthAndRates/Deposit"
import { useDispatch, useSelector } from "react-redux"
import { errorFieldsSelector } from "modules/errors/selectors"
import { CustomInputError } from "ui/CustomInputError"
import { receiveErrors } from "modules/errors/reducer"
import PropTypes from "prop-types"

export const LengthAndRates = ({
  form,
  isShowErrorMessage,
  setIsShowErrorMessage,
  localPrices,
  onPriceSave,
  onPriceDelete,
  expandedRowData,
  setExpandedRowData
}) => {
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const pricingType = Form.useWatch("pricing_type", form) || PRICING_TYPES.PER_PERSON
  const [draftPrices, setDraftPrices] = useState([])

  const errors = useSelector(errorFieldsSelector())

  const addNewPrice = () => {
    setDraftPrices((prev) => [...prev, { id: generateUUID() }])
    setExpandedRowData(null)
    dispatch(
      receiveErrors({
        data: { message: { listing_media: [] } },
        showToast: false
      })
    )
  }

  // Prices to display: locally managed, excluding destroyed entries
  const displayPrices = localPrices.filter((p) => !p._destroy)

  return (
    <Card title={t("experiences.scheduling.sections.length_and_rates.title")} className="mb-3xl">
      <Flex vertical gap={spacings.XL}>
        <Flex align="center" justify="space-between" className="gap-3 lengthRatewrapper flex-wrap">
          <PricingTypeSelector
            value={pricingType}
            setPricingType={(val) => form.setFieldValue("pricing_type", val)}
            form={form}
            setIsShowErrorMessage={setIsShowErrorMessage}
          />
          <Button color="primary" variant="solid" size="large" onClick={addNewPrice}>
            <Icon type="feather" name="Plus" color="currentColor" />
            {t("experiences.scheduling.sections.length_and_rates.add_new")}
          </Button>
        </Flex>
        <LocalPricingTable
          prices={displayPrices}
          draftPrices={draftPrices}
          setDraftPrices={setDraftPrices}
          addNewPrice={addNewPrice}
          setExpandedRowData={setExpandedRowData}
          expandedRowData={expandedRowData}
          setPricingType={(val) => form.setFieldValue("pricing_type", val)}
          pricingType={pricingType}
          form={form}
          isFlatRate={pricingType === PRICING_TYPES.FLAT_RATE}
          onPriceSave={onPriceSave}
          onPriceDelete={onPriceDelete}
        />
        <Button color="primary" variant="link" size="large" className="p-0 mr-auto" onClick={addNewPrice}>
          <Icon type="feather" name="Plus" color="currentColor" />
          {t("experiences.scheduling.sections.length_and_rates.add_new")}
        </Button>
        {isShowErrorMessage && errors.listing_rates && <CustomInputError errorKey={errors.listing_rates[0]} />}
        <FullPayment />
        <Deposit form={form} />
      </Flex>
    </Card>
  )
}

LengthAndRates.propTypes = {
  form: PropTypes.object.isRequired,
  isShowErrorMessage: PropTypes.bool.isRequired,
  setIsShowErrorMessage: PropTypes.func.isRequired,
  localPrices: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPriceSave: PropTypes.func.isRequired,
  onPriceDelete: PropTypes.func.isRequired,
  expandedRowData: PropTypes.object,
  setExpandedRowData: PropTypes.func.isRequired
}
